import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";
import { Component } from "react";

interface HostTokenAuthViewPageProps extends NSARouterMakerResult, CredentialProps { }

class HostTokenAuthViewPage extends Component<HostTokenAuthViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of a Host Token Auth credential, including its name, host, and the token it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
                }}
                pages={{
                    entity: CredentialEntities.host_token_auth(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default HostTokenAuthViewPage;